module.exports = __webpack_public_path__ + "media/images/xpass/icons/instructor_default-5dee94e90002c6bfa96a69a8bee3e3f1.png";